import { render } from "./Message.vue?vue&type=template&id=77400580"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"
script.render = render

export default script